import { Icon } from "@iconify/react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  MenuItem,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import { styled as muiStyled } from "@mui/material/styles";
import styled from "styled-components";

import Badge from "@mui/material/Badge";
import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import { logoutChannel } from "../auth/broadcastSetup";
import { useNavigate } from "react-router-dom";
import { base_url } from "../utils";

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const { profileData } = useSelector((state) => state.profile);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
 
  const handleLogOut = () => {
    axios.post(`${base_url}/EsignServices/LogOut`).then((response) => {
      if (response.data.message === "Logged Out Successfully") {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("email");
        sessionStorage.removeItem("access");
        sessionStorage.removeItem("refresh");
        window.location.replace("/login");
        logoutChannel.postMessage("logout");
      }
    });
  };

  return (
    <Wrapper>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
            },
          }),
        }}
      >
        <Stack
          direction={"row"}
          spacing={1}
          alignItems={"center"}
          justifyContent={"start"}
        >
          <StyledBadge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            variant="dot"
          >
            <Avatar
              sx={{ border: "1px solid #cccccc", width: 51, height: 51 }}
              alt={profileData.company_name}
              src={profileData.logo}
            />
          </StyledBadge>
          <Stack alignItems={"start"} sx={{ color: "black" }}>
            <Typography variant="h6">{profileData.company_name}</Typography>
            <Stack
              alignItems={"center"}
              direction="row"
              sx={{ color: "black" }}
            >
              <p style={{ fontSize: "small" }}>{profileData.company_email}</p>
              <Icon icon="material-symbols:arrow-drop-down" />
            </Stack>
          </Stack>
        </Stack>
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: "auto",
            "& .MuiMenuItem-root": {
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {profileData.company_email}
          </Typography>
        </Box>
        <Divider sx={{ borderStyle: "dashed" }} />
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="body2" noWrap>
            User Name :{" " + profileData.username}
          </Typography>
        </Box>

        {/* <Divider sx={{ borderStyle: "dashed" }} />
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="body2" noWrap>
            Negative Index :{" " + profileData.isNegativeRunning}
          </Typography>
        </Box> */}

        <Divider sx={{ borderStyle: "dashed" }} />

        <MenuItem onClick={handleLogOut} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>
    </Wrapper>
  );
}

const StyledBadge = muiStyled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const Wrapper = styled.div`
  .MuiAvatar-img {
    height: fit-content;
  }
`;
